import { Button, Icon } from 'antd';
import React, { memo } from "react";

import addMoreDataButton from "./AddMoreDataButton.module.scss";

const AddMoreDataButton = memo(({ text, onClick, styles }) => {
	return (
		<div
			className={addMoreDataButton.container}
			style={styles}
			onClick={onClick}
		>
			<Icon className={addMoreDataButton.icon} type="plus-circle" />
			<div className={addMoreDataButton.text}>{text}</div>
		</div>
	);
});

export default AddMoreDataButton;
